import { queryOptions, useQuery } from '@tanstack/react-query';

import { type FieldType } from '~entities/classes/modal/class-search';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetAllClassesForCSVResponse {
  title: string;
  location?: {
    _id?: string;
    fieldName?: string;
    fieldType?: typeof FieldType.Location;
  };
  days: Array<string>;
  startTime: string; // ISO date string
  endTime: string; // ISO date string
  duration: number;
  registrationStartDate: string; // ISO date string
  startDate: string; // ISO date string
  endDate: string; // ISO date string
  tuitionFee: number;
  maxSize: number;
  tuitionBillingCycle: string;
  registrationFeeAmount: number;
  description: string;
  startYear: number;
  startMonth: number;
  endYear: number;
  endMonth: number;
  room: string;
  instructor: Array<string>;
  tags: Array<string>;
  group: Array<string>;
  policyGroup: Array<string>;
}

export const getAllClassesForCSV_API = async () => {
  const response = await baseAPI.get<Array<GetAllClassesForCSVResponse>>(
    `/enrollments/get/all/csv`,
  );
  return response.data;
};

export const getAllClassesForCSVQueryOptions = (enabled: boolean) =>
  queryOptions({
    queryKey: [KEYS.CLASSES_CSV],
    queryFn: () => getAllClassesForCSV_API(),
    enabled: enabled,
    staleTime: 1000 * 60 * 5,
  });

export const useGetAllClassesForCSV = ({ enabled }: { enabled: boolean }) => {
  return useQuery(getAllClassesForCSVQueryOptions(enabled));
};
